module.exports = __webpack_public_path__ + "static/gold_btn-062eb73654772a215184.png";